export default __webpack_public_path__ + "static/logo-e0c4d684432369b0594f14ff14b218dd.svg";